module.exports = __webpack_public_path__ + "static/ChiBottlePromo1-014a2f4aed74ea2edb6e89e0e7ebd589.jpg";